import { PricingCalculator } from "@/landing/PricingCalculator";
import { Link } from "react-router-dom";
import { PublicLayout } from "@/landing/PublicLayout";
import { Offers } from "@/landing/Offers";
import { EVENT_PASS_SIZES, SUBSCRIPTION_PRICES } from "@/data/offers";

export function PricingPage() {
  return (
    <PublicLayout>
      <section className="sc-container sc-pricing-hero">
        <p className="sc-eyebrow">Pricing</p>
        <h1>
          Start small.
          <br />
          Run with confidence.
        </h1>
        <p className="sc-lead">
          Two small competitions a year free. Choose one event or a whole club calendar when paid
          plans become available.
        </p>
        <p className="sc-notice">
          Paid plans are not on sale yet. Free accounts and the read-only demo are available now.
        </p>
      </section>
      <section className="sc-container" aria-label="Compare plans">
        <h2 className="sc-sr-only">Compare plans</h2>
        <Offers />
      </section>
      <section className="sc-container sc-section sc-split">
        <div>
          <p className="sc-eyebrow">One competition, one payment</p>
          <h2>Choose your Event pass by entries.</h2>
          <p>
            A rider in two divisions counts as two entries. Upgrade by paying the difference. A pass
            is used when the first heat starts.
          </p>
          <p>
            Unused passes are refundable before the first heat starts, provided no paid entries were
            taken. After 180 days, contact support for a refund.
          </p>
        </div>
        <div className="sc-panel">
          <h3>Event pass sizes</h3>
          <table className="sc-compare">
            <thead>
              <tr>
                <th scope="col">Size</th>
                <th scope="col">Up to</th>
                <th scope="col">Price</th>
              </tr>
            </thead>
            <tbody>
              {EVENT_PASS_SIZES.map((size) => (
                <tr key={size.key}>
                  <th scope="row">{size.label}</th>
                  <td>{size.entries} entries</td>
                  <td>USD {size.usd}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <p className="sc-secondary">
            More than 250 entries? Choose Club Unlimited or{" "}
            <a href="mailto:hello@scorio.live">contact us</a> for a quote.
          </p>
        </div>
      </section>
      <section className="sc-container sc-section sc-split">
        <div>
          <p className="sc-eyebrow">What the offer covers</p>
          <h2>Public and broadcast essentials.</h2>
          <p>
            The Event pass unlocks shipped Club-level features for one competition. Club Unlimited
            covers your competition calendar.
          </p>
          <p>
            Running more than 16 small events a year, planning a series or interested in templates
            and athlete accounts? Consider Club Unlimited as those features arrive.
          </p>
        </div>
        <div className="sc-panel">
          <h3>Available scope</h3>
          <p>
            Browser judging, OBS overlays, public results, TV mode, heat timers, sponsor placements
            and core exports. Advanced formats and registration follow the roadmap.
          </p>
          <p className="sc-secondary">
            Every plan supports up to 16 judges. Free includes a watermarked overlay; an Event pass
            or Club Unlimited removes the watermark.
          </p>
          <Link className="sc-text-link" to="/results/demo">
            Try the current foundation →
          </Link>
        </div>
      </section>
      <PricingCalculator />
      <section className="sc-container sc-section sc-pricing-extra">
        <p className="sc-eyebrow">Coming later</p>
        <h2>A clear boundary around what’s next.</h2>
        <h3>Tour · planned</h3>
        <p>
          USD {SUBSCRIPTION_PRICES.tour.monthly}/month or USD{" "}
          {SUBSCRIPTION_PRICES.tour.annual.toLocaleString("en-US")}/year. Advanced series,
          organisation tools and API access are planned. Tour is not on sale.
        </p>
        <h3>Paid entries · planned</h3>
        <p>
          Planned Scorio fee: 3% with an Event pass or Club Unlimited; 0% with Tour. Stripe fees
          apply and are paid by the organiser. Paid registration is not available today.
        </p>
        <p className="sc-note">
          Roadmap features have no confirmed launch date. Registration fee controls in the
          calculator stay hidden until paid registration ships.
        </p>
      </section>
      <section className="sc-container sc-final">
        <h2>See your next event clearly.</h2>
        <div className="sc-actions">
          <Link className="sc-button sc-button-primary" to="/login">
            Start free
          </Link>
          <Link className="sc-button" to="/results/demo">
            Try demo
          </Link>
        </div>
        <p className="sc-note">Free to sign up. Two small events a year free.</p>
      </section>
    </PublicLayout>
  );
}
